import IotGovPlatformPage from './pages/IotGovPlatform';

export default [{
    path: '/iot/gov-platform',
    title: 'IOT政府平台',
    component: IotGovPlatformPage,
}]